// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@ces/XDL/types";

export default {
    isCompactHeader: true,
    triggerPoint: 140,
    backgroundColor: "common.ui1",
    linkColor: "#fff",
    isDropShadow: false,
    dropShadowStyle: "medium",
    isBorderTop: false,
    isBorderBottom: false,
    isBorderRight: false,
    isBorderLeft: false,
    borderThickness: 0,
    borderColor: "#999",
    padding: 0,
    isBorder: false,
    isFullWidth: true,
} as xBaseTheme["header"];
